import { createSelector } from '@reduxjs/toolkit';
import { selectItemById } from '../common';
import { permissionsAdapter } from '../../slices/features/permissions.slice';
import { RootState } from '../../store';
import { ApplicationPermissions } from '../../../components/Common';
import { getTenant, getTenantSettings, getUser } from './common.selectors';

export const {
    selectAll: getAllPermissions, selectById: getPermissionById, selectIds: getPermissionStrings,
} = permissionsAdapter.getSelectors<RootState>((state) => state.permissions);

export const getUserHasSelfDispatchAccess = createSelector(
    getPermissionStrings,
    getTenantSettings,
    getTenant,
    getUser,
    (permissions, tenantSettings, tenant, user) => {
        if (!tenantSettings?.enableSelfDispatchTimesheets) {
            return false;
        }

        if (tenant?.id !== user?.companyTenantId) {
            return false;
        }

        return user?.employeeId && user.employeeId > 0 && permissions.includes(
            ApplicationPermissions.nonFlagging_timesheet_create,
        );
    },
);

export const checkUserHasPermission = createSelector(
    getPermissionStrings,
    selectItemById,
    (permissions, permission) => {
        // Example: location.view -> ["location", "view"] -> category: location, action: view
        const [category, action] = (permission ?? '').split('.');

        if (!permissions || !category || !action) return false;

        const hasPerm = permissions.some((p) => {
            const [p_permission, p_action] = (p || '').split('.');

            return p_permission === category && p_action === action;
        });

        return hasPerm;
    },
);